import { render, staticRenderFns } from "./CollectionRequestImport.vue?vue&type=template&id=dc81353e&scoped=true&"
import script from "./CollectionRequestImport.vue?vue&type=script&lang=ts&"
export * from "./CollectionRequestImport.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionRequestImport.vue?vue&type=style&index=0&id=dc81353e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc81353e",
  null
  
)

export default component.exports